(function() {

    'use strict';

    angular.module('app').config(serviceTicketUrlConfig);

    serviceTicketUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function serviceTicketUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.
        when('/service-tickets/view/:id', {
            templateUrl: '/templates/pages/service-request/service-ticket-details.html',
            controller: 'ServiceTicketDetailsController',
            controllerAs: 'vm',
            params: {
                icon: 'fa fa-pencil',
                parent: 'serviceTickets',
                htmlTitle: 'Service Ticket Details',
                pageTitle: 'Service Ticket Details'
            }
        })

        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }
}
)()


// WEBPACK FOOTER //
// ./js/urls/service-ticket.js